/**
 * Normalize dashboard section fields between API (section_name, max_widgets_per_row)
 * and editor UI (name, columns).
 */
export function normalizeSection(section, widgetsOverride) {
  if (!section) return section;
  const name = section.name || section.section_name || 'Untitled Section';
  const columns = section.columns ?? section.max_widgets_per_row ?? 2;
  const widgets =
    widgetsOverride !== undefined ? widgetsOverride : section.widgets || [];

  return {
    ...section,
    name,
    section_name: section.section_name || name,
    columns,
    max_widgets_per_row: section.max_widgets_per_row ?? columns,
    widgets,
  };
}

export function normalizeSections(sections) {
  return (sections || []).map((s) => normalizeSection(s));
}

export function sectionDisplayName(section) {
  return section?.name || section?.section_name || 'Untitled Section';
}

export function sectionColumns(section) {
  return section?.columns ?? section?.max_widgets_per_row ?? 2;
}

/** Payload for POST/PUT /api/dashboards/:id/sections */
export function sectionApiPayload({ name, columns, section_name, max_widgets_per_row }) {
  return {
    section_name: section_name || name,
    max_widgets_per_row: max_widgets_per_row ?? columns ?? 2,
  };
}
